import { FC } from 'react';

import './NotFound.scss';

const NotFound: FC = () => {
  return (
    <>
      <section className="NotFound">Page Not Found 404 Error</section>
    </>
  );
};

export { NotFound };
